import React from "react";
import { Eye, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ImpersonationBanner = () => {
  const { impersonating, user, stopImpersonating } = useAuth();
  if (!impersonating) return null;
  const exit = () => { stopImpersonating(); window.location.href = "/admin/users"; };
  return (
    <div data-testid="impersonation-banner" className="sticky top-0 z-[60] bg-[#FF5C00] text-white px-4 py-2 flex items-center justify-center gap-3 text-[14px] font-medium">
      <Eye size={15} />
      Viewing as <span className="font-semibold">{user?.name || user?.email}</span> ({user?.role})
      <button data-testid="impersonation-exit-btn" onClick={exit} className="ml-2 inline-flex items-center gap-1 bg-black/25 hover:bg-black/40 rounded-full px-3 py-1 transition-colors">
        <X size={13} /> Exit
      </button>
    </div>
  );
};

export default ImpersonationBanner;
